import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-8 ${className}`} data-id="element-256">
      <div className="max-w-3xl mx-auto" data-id="element-257">{children}</div>
    </section>;
}